module.exports = __webpack_public_path__ + "static/media/send.8a3fe573.svg";